import { withStyles } from '@material-ui/core';
import React, { forwardRef, Fragment } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { getI18n } from 'react-i18next';
const RecaptchaWrapper = withStyles(() => ({
    '@global': {
        '.grecaptcha-badge': {
            zIndex: 99999999,
        },
        '#rc-imageselect': {
            zIndex: 99999999,
        },
    },
}), { name: 'RecaptchaWrapper' })(Fragment);
const Recaptcha = forwardRef((props, ref) => (React.createElement(RecaptchaWrapper, null,
    React.createElement(ReCAPTCHA, Object.assign({ ref: ref }, props, { hl: getI18n().language, sitekey: process.env.REACT_APP_RECAPTCHA, size: 'invisible' })))));
export default Recaptcha;
